import { useQuery as n } from "react-query";
import { useEnvironment as a } from "../../../common/hooks/environment/useEnvironment.js";
import { useAuth as c } from "../../../auth/hooks/useAuth.js";
import { getAdapter as i } from "../../adapter.js";
import { VoucherAdapter as m } from "../../models/voucher/voucher.adapter.js";
function l() {
  const {
    backendBaseUrl: e
  } = a(), {
    customer: o
  } = c();
  return n(
    ["customer-vouchers"],
    async () => {
      var t;
      const r = await (await fetch(`${e}/loyalty-promotion/?loyalty_id=${(t = o == null ? void 0 : o.activity.loyalty) == null ? void 0 : t.code}`, {
        method: "GET"
      })).json(), s = i(m);
      return (r.items ?? []).map(s.adapt);
    },
    {
      refetchOnWindowFocus: !1
    }
  );
}
export {
  l as useVouchers
};
//# sourceMappingURL=useVouchers.js.map
